import CamposEstadioNombre from '../campos/CamposEstadioNombre.js';
import TablaEstadioNombres from '../tablas/TablaEstadioNombres.js';
import * as Campos from '../../constantes/Campos.js';
import * as FuncionesFecha from '../../funciones/FuncionesFecha.js';

// Funciones para CuadroEditableLista

export const armarFilasTabla = (lista, idElegido, onEditarItem, onEliminarItem) => {
  return (
    <TablaEstadioNombres
      lista={lista}
      idElegido={idElegido}
      onEditarItem={onEditarItem}
      onEliminarItem={onEliminarItem}
    />
  );
};

export const OrdenarLista = (itemA, itemB) => {
  const fechaDesdeA = FuncionesFecha.CamposToDate(itemA.anioDesde, itemA.mesDesde, itemA.diaDesde);
  const fechaDesdeB = FuncionesFecha.CamposToDate(itemB.anioDesde, itemB.mesDesde, itemB.diaDesde);
  return fechaDesdeA - fechaDesdeB;
};

// Funciones para EditarItemLista

export const CamposEdicion = (idPadre, item, editar, actualizar, onCampoChange) => {
  return (
    <CamposEstadioNombre
      idPadre={idPadre}
      item={item}
      editar={editar}
      actualizar={actualizar}
      onCampoChange={onCampoChange}
    />
  );
};

export const OnCampoChange = (item, campo, valor) => {
  switch (campo) {
    // básicos
    case Campos.NombreEstadio.NOMBRE: {
      return { ...item, nombre: valor };
    }
    case Campos.NombreEstadio.FECHA_DESDE: {
      return {
        ...item,
        anioDesde: valor[FuncionesFecha.ANIO],
        mesDesde: valor[FuncionesFecha.MES],
        diaDesde: valor[FuncionesFecha.DIA],
      };
    }
    case Campos.NombreEstadio.FECHA_HASTA: {
      return {
        ...item,
        anioHasta: valor[FuncionesFecha.ANIO],
        mesHasta: valor[FuncionesFecha.MES],
        diaHasta: valor[FuncionesFecha.DIA],
      };
    }
    case Campos.NombreEstadio.OBSERVACIONES: {
      return { ...item, observaciones: valor };
    }
    default: {
      throw new Error('Campo ' + campo + ' no definido');
    }
  }
};

export const ValidarItemGrabar = (item) => {
  let error = '';
  if (!item) {
    error = 'No se informaron datos para el nombre del estadio';
  } else if (!item.nombre || item.nombre === '') {
    error = 'Debe ingresar el nombre del estadio';
  } else if (!item.anioDesde) {
    error = 'Debe indicar al menos el año desde';
  } else if (
    item.anioDesde < FuncionesFecha.ANIO_MINIMO ||
    item.anioDesde > FuncionesFecha.ANIO_MAXIMO
  ) {
    error = 'La fecha desde es inválida';
  } else {
    const fechaDesde = FuncionesFecha.CamposToFechaBaseInicial(
      item.anioDesde,
      item.mesDesde,
      item.diaDesde
    );
    if (!fechaDesde < FuncionesFecha.FechaBaseMinima()) {
      error = 'La fecha desde es inválida';
    }
    if (item.anioHasta) {
      if (
        !item.anioHasta ||
        item.anioHasta < FuncionesFecha.ANIO_MINIMO ||
        item.anioHasta > FuncionesFecha.ANIO_MAXIMO
      ) {
        error = 'La fecha hasta es inválida';
      } else {
        const fechaHasta = FuncionesFecha.CamposToFechaBaseFinal(
          item.anioHasta,
          item.mesHasta,
          item.diaHasta
        );
        if (fechaDesde > fechaHasta) {
          error = 'La fecha desde no puede ser posterior a la fecha hasta';
        }
      }
    }
  }
  return error;
};
